// TODO: Добавить тип из новой ручки в CD-203174
export function mkMarkedList() {
  return {
    items: [
      {
        title: '<h2>Для кого подходит материнский капитал</h2>',
        content: '<b>Для матерей</b>',
      },
      {
        title: '<h2>Для кого не подходит материнский капитал</h2>',
        content: 'Для отцов',
      },
      {
        title: '📏 Какие условия у семейной ипотеки?',
        content: `
          📍 Базовая ставка по семейной ипотеке составляет 6% годовых, а на Дальнем Востоке — 5% годовых. Такая ставка действует весь срок кредита. Ставка может быть выше, если не оформить личное страхование. Также ставку могут снизить для зарплатных клиентов или благодаря скидкам банка или застройщика.
          💰 Максимальная сумма семейной ипотеки равна:
          12 миллионам ₽ — для жилья в Москве, Московской области, Санкт-Петербурге и Ленинградской области;
          6 миллионам ₽ — для жилья в остальных регионах РФ. `,
      },
    ],
  };
}
